
    import { mapActions, mapMutations } from 'vuex';
    import { ValidationProvider } from 'vee-validate';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faMapMarkerAlt as farMapMarkerAlt,
    } from '@fortawesome/pro-regular-svg-icons/faMapMarkerAlt';

    import C1TypeaheadMultiSelect from '@/C1Components/C1TypeaheadMultiSelect.vue';
    import C1TagsContainer from '@/C1Components/C1TagsContainer.vue';
    import C1Tag from '@/C1Components/C1Tag.vue';
    import C1Spinner from '@/C1Components/C1Spinner';
    import C1HelpText from '@/C1Components/C1HelpText';
    import SeekerAttributesNoResult from '@/components/Seeker/SeekerAttributesNoResult';

    export default {
        name: 'SeekerLocations',

        components: {
            SeekerAttributesNoResult,
            ValidationProvider,
            C1HelpText,
            C1Spinner,
            C1TypeaheadMultiSelect,
            C1TagsContainer,
            C1Tag,
            FontAwesomeIcon,
        },

        props: {
            minItems: {
                type: Number,
                default: 0,
            },

            hideNoResultMessage: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                label: 'Desired work locations',
                id: `location_${this._uid}`,
                locationsSelected: [],
                locationsSearched: [],
                spinner: {
                    get_work_locations: false,
                },
                icons: {
                    farMapMarkerAlt,
                },
            };
        },

        computed: {
            noResultText() {
                return `No ${this.label.toLowerCase()} added.`;
            },

            fieldValidation() {
                return this.locationsSelected.length;
            },

            validationRules() {
                return this.minItems ? `min_value:${this.minItems}` : '';
            },
        },

        created() {
            this.getWorkLocations();
        },

        methods: {
            ...mapActions('location', {
                $_getLocations: 'getLocations',
            }),

            ...mapActions('me', {
                $_getWorkLocations: 'getWorkLocations',
                $_attachWorkLocation: 'attachWorkLocation',
                $_detachWorkLocation: 'detachWorkLocation',
            }),

            ...mapMutations('me', {
                $_PUT_WORK_LOCATION: 'PUT_WORK_LOCATION',
                $_DESTROY_WORK_LOCATION: 'DESTROY_WORK_LOCATION',
            }),

            getWorkLocations() {
                this.spinner.get_work_locations = true;
                this.$_getWorkLocations().then((response) => {
                    this.locationsSelected = response.data;
                }).finally(() => {
                    this.spinner.get_work_locations = false;
                });
            },

            searchLocations(query) {
                this.$_getLocations({ query }).then((response) => {
                    this.locationsSearched = response.data;
                });
            },

            attachLocation(location) {
                this.locationsSelected.push(location);
                this.$_attachWorkLocation(location.id).then(() => {
                    this.$_PUT_WORK_LOCATION(location);
                });
            },

            detachLocation(location) {
                const loc = this.locationsSelected.findIndex(o => o.id === location.id);
                this.locationsSelected.splice(loc, 1);
                this.$_detachWorkLocation(location.id).then(() => {
                    this.$_DESTROY_WORK_LOCATION(location.id);
                });
                this.validate();
            },

            validate() {
                this.$nextTick(() => {
                    this.$refs.fieldLocation.validate();
                });
            },
        },
    };
